module.exports = __webpack_public_path__ + "img/Miao ZhiCheng.4e8f29c2.jpg";